import {NodeName} from "./nodeName.mjs";
import {Node} from "../../node/node.mjs";

class Text {

    consume(tokenIterator, nodeIterator) {

        let value = tokenIterator.token().value;
        let lastCreatedNode = this.getPreviousSibling(nodeIterator)

        if(this.isTextNode(lastCreatedNode)) {
            lastCreatedNode.value += value
        } else {
            nodeIterator.addClosedNode(
                new Node(NodeName.TEXT, value, null, nodeIterator.currentParentNode).close()
            )
        }

        tokenIterator.index++
    }

    onEndOfMarkup(openNode) {
    }

    toHtml(node, toHtml, idProvider) {
        return node.value
    }


    getPreviousSibling(nodeIterator) {
        if (nodeIterator.currentParentNode.children.length < 1) return null
        return nodeIterator.currentParentNode.children[nodeIterator.currentParentNode.children.length - 1];
    }

    isTextNode(node) {
        return !!node && node.name === NodeName.TEXT
    }

}

export {Text}